import {Button, Card, Typography, styled} from "@mui/material";
import React from "react";
import {useLocation, useNavigate} from "react-router-dom";

const GuideTextContainer = styled(Card)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& h4": {
    marginBottom: "16px",
    color: theme.palette.success.dark,
    lineHeight: 1.5,
    fontWeight: 600,
  },

  "& p": {fontSize: "16px", color: theme.palette.warning.dark, fontWeight: 600, lineHeight: 1.5},

  "& button": {
    marginTop: "32px",
  },
}));

const ExamResult = () => {
  const {state} = useLocation();
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <GuideTextContainer>
        <Typography variant="h4">응시 결과</Typography>
        <Typography>
          총 <span style={{fontSize: "18px", fontWeight: 600}}>{state.length}</span>의 문항 중{" "}
          <span style={{fontSize: "18px", fontWeight: 600}}>{state.correct}</span>의 답을
          맟췄습니다.
        </Typography>
        <Typography>
          100점 만점 중 <span style={{fontSize: "18px", fontWeight: 600}}>{state.score}</span>
          점입니다.
        </Typography>
        <Button
          variant="contained"
          color="success"
          size="large"
          onClick={() => {
            navigate("/Education/MyEval");
          }}
          autoFocus={true}
        >
          확인
        </Button>
      </GuideTextContainer>
    </React.Fragment>
  );
};

export default ExamResult;
